<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Attendance</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-progress-linear
      slot="progress"
      color="primary"
      height="3"
      indeterminate
      v-show="progressBar"
    ></v-progress-linear>
    <v-card>
      <v-card-text>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="BatchId"
                    :items="batches"
                    item-text="Name"
                    name="BatchName"
                    label="Batch Name"
                    id="BatchName"
                    required
                    item-value="Id"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-menu
                    v-model="dobPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        name="Date"
                        id="Date"
                        label="Date"
                        hint="YYYY-MM-DD format"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      @input="dobPicker = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="cancel">Reset</v-btn>
            <v-btn color="primary darken-1" @click="takeAttendance"
              >Take Attendance</v-btn
            >
          </v-card-actions>
        </v-card>

        <template v-if="isAttendanceDataLoaded">
          <v-data-table
            :headers="headers"
            :items="batchStudents"
            :pagination.sync="pagination"
            :loading="progressBar"
            item-key="Id"
            class="elevation-1"
            select-all
            :rows-per-page-items="rowsPerPageItems"
          >
            <template v-slot:progress>
              <v-progress-linear
                slot="progress"
                color="blue"
                height="2"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:headers="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.stop="toggleAll"
                    v-if="!isAttendanceTaken"
                  ></v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : ''
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr :active="isSelected(props.item.Id)">
                <td>
                  <v-checkbox
                    v-model="selected"
                    primary
                    hide-details
                    @click.stop="selectItem(props.item.Id)"
                    :value="props.item.Id"
                    v-if="!isAttendanceTaken"
                  ></v-checkbox>
                </td>
                <td
                  v-for="(value, index) in tableDisplayFields"
                  :key="index"
                  class="text-xs-center"
                >
                  {{ props.item[value] }}
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <td :colspan="headers.length + 1">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-show="selected.length > 0"
                  @click="markAttendance"
                  >Mark Attendance</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import StudentStore from "../db/studentStore";
import dbStore from "../db/dbStore";
import Utils from "../utils";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Attendance",
  data: function() {
    return {
      valid: false,
      progressBar: false,
      dobPicker: false,
      isAttendanceTaken: false,
      isAttendanceDataLoaded: false,
      showButton: true,
      students: [],
      studentsprogress: [],
      batchStudents: [],
      batches: [],
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        sortBy: "name",
        rowsPerPage: 30
      },
      selected: [],
      headers: [
        {
          text: "First Name",
          align: "center",
          sortable: true,
          value: "FirstName"
        },
        { text: "Last Name", value: "LastName", align: "center" },
        { text: "Attendance", value: "AttendanceStatus", align: "center" },
        { text: "Status", value: "Status", align: "center" }
      ],
      tableDisplayFields: [
        "FirstName",
        "LastName",
        "AttendanceStatus",
        "Status"
      ],
      BatchId: "",
      date: "",
      status: "",
      student: {},
      batch: {
        Id: "",
        Name: "",
        Center: "",
        StartDate: "",
        EndDate: "",
        NoOfStudents: "",
        Students: [],
        ServicesOffered: ""
      }
    };
  },
  watch: {},
  created() {
    this.getData();
  },
  computed: {
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },
  methods: {
    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("batches");
      this.batches = await dbStore.getItems();
      dbStore.setCollectionName("students");
      this.students = await dbStore.getItems();
      dbStore.setCollectionName("studentprogress");
      this.studentsprogress = await dbStore.getItems();
      this.batches = await this.getBatchesForCurrentCenter(this.batches)
      this.progressBar = false;
      this.selected = [];
    },
    async getBatchesForCurrentCenter(batches) {
      var temp = []
      var centerId = this.login_details.centerId
      await batches.forEach(async batch => {
        if(centerId == 0 || batch.CenterId === centerId) {
          temp.push(batch)
        }
      });
      return temp
    },

    getAttendanceDetails() {
      this.isAttendanceDataLoaded = false;
      this.batch = Utils.getItemFromListWithId(this.batches, this.BatchId);
      this.mapIdsWithNames(this.students);
      this.getIsAttendanceTakenForDate(this.date);
      this.getAttendanceOfStudentsForDate(this.date);
      this.isAttendanceDataLoaded = true;
    },

    getIsAttendanceTakenForDate(date) {
      var attendaceKeys = [];
      var attendace = {};
      Object.assign(attendace, this.batchStudents[0]["Attendance"]);
      if (attendace) {
        attendaceKeys = Object.keys(attendace);
        var isDateExists = attendaceKeys.indexOf(date);
        if (isDateExists > -1) {
          this.isAttendanceTaken = true;
        } else {
          this.isAttendanceTaken = false;
        }
      } else {
        this.isAttendanceTaken = false;
      }
    },

    getAttendanceOfStudentsForDate(date) {
      var attendaceKeys = [];
      var attendace = {};
      this.batchStudents.forEach(element => {
        //#TODO change to enums
        Object.assign(attendace, element["Attendance"]);
        if (attendace) {
          attendaceKeys = Object.keys(attendace);
          var isDateExists = attendaceKeys.indexOf(date);
          if (isDateExists > -1) {
            if (attendace[date]) {
              element["AttendanceStatus"] = "Present";
            } else {
              element["AttendanceStatus"] = "Absent";
            }
          } else {
            element["AttendanceStatus"] = "N/A";
          }
        } else {
          element["AttendanceStatus"] = "N/A";
        }
      });
    },

    async markAttendance() {
      let response;
      try {
        var payload = this.getTodayAttendanceOfAllStudentsInBatch();
        //console.log(payload)
        response = await StudentStore.markAttendance(payload, this.date);

        if (response.isCommitted) {
          this.getData();
          this.cancel();
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error marking attendance : " + err);
      }
    },

    //#TODO Move to generalized component
    isSelected(Id) {
      if (this.selected.indexOf(Id) > -1) {
        return true;
      } else {
        return false;
      }
    },

    //#TODO Move to generalized component
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else {
        var ids = [];
        this.batchStudents.forEach(element => {
          ids.push(element.Id);
        });
        this.selected = ids;
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    //#TODO Move to generalized component
    selectItem(Id) {
      var isExists = this.isSelected(Id);
      //console.log(Id + " exists "+ isExists + " index -> "+index)
      if (isExists) {
        //value already exists so remove
        var index = this.selected.indexOf(Id);
        this.selected.splice(index, 1);
        return false;
      } else {
        //value doesnt exists so add it up
        this.selected.push(Id);
        return true;
      }
    },

    //#TODO Move to generalized component
    getSelectedStudents() {
      //set students with approved status
      var self = this;
      var students = [];
      this.students.forEach(function(value) {
        var Id = value.Id;
        self.selected.forEach(element => {
          if (element == Id) students.push(element);
        });
      });

      return students;
    },

    getTodayAttendanceOfAllStudentsInBatch() {
      var self = this;
      var payload = {};
      this.batchStudents.forEach(function(value) {
        var Id = value.Id;
        payload[Id] = { status: false, studentInfo: value };
        self.selected.forEach(element => {
          if (element == Id) {
            payload[Id]["status"] = true;
          }
        });
      });

      return payload;
    },

    mapIdsWithNames(students) {
      var studentObjects = [];
      var validStudents = [];

      students.forEach(item => {
        var Id = item.Id;
        if (this.batch.Students != undefined && this.batch.Students != "") {
          this.batch.Students.forEach(student => {
            if (student == Id) studentObjects.push(item);
          });
        }
      });
      studentObjects.forEach(element => {
        var Id = element.Id;
        var studentProgress = Utils.getItemFromListWithId(
          this.studentsprogress,
          Id
        );
        var droppedOut = studentProgress.dropped_out;
        if (droppedOut != undefined && droppedOut == false) {
          validStudents.push(element);
        }
      });
      this.batchStudents = validStudents;
    },

    cancel() {
      this.BatchId = "";
      this.date = "";
      this.isAttendanceDataLoaded = false;
      this.isAttendanceTaken = false;
      this.showButton = true;
    },

    takeAttendance() {
      this.showButton = false;
      this.getAttendanceDetails();
    },
    
    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>
